import { render, staticRenderFns } from "./DashboardCustomerDueTable.vue?vue&type=template&id=725501af"
import script from "./DashboardCustomerDueTable.vue?vue&type=script&lang=ts"
export * from "./DashboardCustomerDueTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports